const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.120968,0,0,0.120968,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,69.2C29.6,69.2 0,94 0,137.2L0,260.4C3.2,275.6 19.2,286.8 36.8,286.8C56.8,286.8 71.2,272.4 71.2,254.8L71.2,192.4L125.6,192.4L125.6,254C125.6,288.4 81.6,306 49.6,306C31.2,306 13.6,300.4 0.8,290.8L0.8,426.8L87.2,426.8C117.6,426.8 152.8,398 152.8,361.2L152.8,69.2L68,69.2Z",
    style: {
      fill: "rgb(17,116,206)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,137.2L0,260.4C3.2,275.6 19.2,286.8 36.8,286.8C56.8,286.8 71.2,272.4 71.2,254.8L71.2,192.4L125.6,192.4L125.6,254C125.6,288.4 81.6,306 49.6,306C31.2,306 13.6,300.4 0.8,290.8L0.8,426.8L87.2,426.8C117.6,426.8 152.8,398 152.8,361.2L152.8,69.2",
    style: {
      fill: "rgb(15,84,157)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,192.4L124.8,254C124.8,288.4 80.8,306 48.8,306C30.4,306 12.8,300.4 0,290.8L0,426.8L86.4,426.8C116.8,426.8 152,398 152,361.2",
    style: {
      fill: "rgb(2,55,94)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,285.2L408,285.2C417.6,285.2 426.4,276.4 426.4,266.8C426.4,257.2 417.6,248.4 408,248.4L370.4,248.4L370.4,285.2Z",
    style: {
      fill: "rgb(20,102,67)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.8,69.2C373.6,69.2 344.8,94 344.8,136.4L344.8,192.4L445.6,192.4C460,192.4 472,204.4 472,218.8C472,233.2 460,245.2 445.6,245.2C461.6,245.2 474.4,256.4 474.4,270.8C474.4,285.2 462.4,296.4 445.6,296.4L344,296.4L344,426.8L430.4,426.8C460.8,426.8 496,398 496,361.2L496,69.2L412.8,69.2Z",
    style: {
      fill: "rgb(27,204,56)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,137.2L344,192.4L444.8,192.4C459.2,192.4 471.2,204.4 471.2,218.8C471.2,233.2 459.2,245.2 444.8,245.2C460.8,245.2 473.6,256.4 473.6,270.8C473.6,285.2 461.6,296.4 444.8,296.4L344,296.4L344,426.8L430.4,426.8C460.8,426.8 496,398 496,361.2L496,69.2",
    style: {
      fill: "rgb(50,153,71)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.2,218.8C471.2,233.2 459.2,245.2 444.8,245.2C460.8,245.2 473.6,256.4 473.6,270.8C473.6,285.2 461.6,296.4 444.8,296.4L344,296.4L344,426.8L430.4,426.8C460.8,426.8 496,398 496,361.2",
    style: {
      fill: "rgb(20,102,67)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.6,222C425.6,212.4 416.8,203.6 407.2,203.6L370.4,203.6L370.4,239.6L408,239.6C417.6,239.6 425.6,231.6 425.6,222Z",
    style: {
      fill: "rgb(20,102,67)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2,69.2C200,69.2 171.2,94 171.2,136.4L171.2,205.2C180.8,197.2 192.8,191.6 205.6,191.6L296.8,191.6L296.8,210.8C275.2,206 254.4,203.6 244,203.6C221.6,203.6 203.2,222 203.2,244.4C203.2,266.8 221.6,285.2 244,285.2C254.4,285.2 275.2,283.6 296.8,278.8L296.8,296.4L205.6,296.4C192.8,296.4 180,291.6 171.2,282.8L171.2,426.8L257.6,426.8C288,426.8 323.2,398 323.2,361.2L323.2,69.2L239.2,69.2Z",
    style: {
      fill: "rgb(226,14,55)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.2,137.2L171.2,206C180.8,198 192.8,192.4 205.6,192.4L296.8,192.4L296.8,211.6C275.2,206.8 254.4,204.4 244,204.4C221.6,204.4 203.2,222.8 203.2,245.2C203.2,267.6 221.6,286 244,286C254.4,286 275.2,284.4 296.8,279.6L296.8,296.4L205.6,296.4C192.8,296.4 180,291.6 171.2,282.8L171.2,426.8L257.6,426.8C288,426.8 323.2,398 323.2,361.2L323.2,69.2",
    style: {
      fill: "rgb(180,31,54)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.8,192.4L296.8,211.6C275.2,206.8 254.4,204.4 244,204.4C221.6,204.4 203.2,222.8 203.2,245.2C203.2,267.6 221.6,286 244,286C254.4,286 275.2,284.4 296.8,279.6L296.8,296.4L205.6,296.4C192.8,296.4 180,291.6 171.2,282.8L171.2,426.8L257.6,426.8C288,426.8 323.2,398 323.2,361.2",
    style: {
      fill: "rgb(114,10,30)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.11822917d10ac570ecc785f3d521aecb.svg";
export { ForwardRef as ReactComponent };